<template>
  <div id="view-container">
    <h5
      v-if="mapInformation.point"
      class="map-title"
    >
      {{ $t("message.map") }}
    </h5>
    <div
      id="view"
      ref="map"
      class="map"
    />
  </div>
</template>

<script>
import { loadModules } from "esri-loader";

export default {
  name: "Map",
  props: {
    mapInformation: {
      type: Object,
      default: () => {
        return {
          coordinates: [-84.3880, 33.7490],
          zoom: 10,
          point: true
        }
      }
    },
  },
  mounted() {
    /* eslint-disable */
    const options = {version: '4.12', css: true}; // explicitly set API version to avoid future breaking changes
    loadModules(['esri/Map', 'esri/Graphic', 'esri/widgets/Locate', 'esri/views/MapView', 'esri/widgets/Home', 'esri/layers/FeatureLayer'], options)
    .then(([Map, Graphic, Locate, MapView, Home, FeatureLayer]) => {        
      const map = new Map({
        basemap: 'streets-vector',
      });
      const view = new MapView({
        map: map,
        container: 'view',
        center: this.mapInformation.coordinates,
        zoom: this.mapInformation.zoom,
        ui: {
          components: ["attribution"]
        }
      });      
      const button = new Home({
        view: view
      });
      const locate = new Locate({
        view: view
      });   
      const projectLimitsLayer = new FeatureLayer({
  url: "https://gis.hntbatl.com/server/rest/services/Hosted/SR20_Widening_Limits/FeatureServer/0?token=NMIkXL2sKEjUCoLLd42LPJhVXr2kmiL8DDLuHqgyjRe1YDmFOPcVKrFNbjc6RpfttkprXQpG_-Tq7HwUVr5Mn-gIaP3KGudkt1C9laATI3RjYNqx9J2nKRGLXFpbB9VG7BkI9A86AAcFwl8q41m5Onm7wJ1of-H1JBowy0u2tzzxmfudWYR4c1wRXaO58AnnMbd-4Zdfx-eA1oWwd5N__PPqNW1k6ZolXNxd6DdiIxE"
});
      view.ui.add(button, "top-left");
      view.ui.add(locate, "top-left");

      map.add(projectLimitsLayer);

      //Only add the firefly click attachment if specified
      if(this.mapInformation.point) {
        view.on("click", (event) => {
          view.graphics.removeAll();
          const coords = view.toMap({x: event.x, y: event.y})
          const point = {
            type: "point",
            longitude: coords.longitude,
            latitude: coords.latitude
          };                            
          const markerSymbol = {
            type: "picture-marker",
            url: "https://static.arcgis.com/images/Symbols/Firefly/FireflyB6.png",
            width: 24,
            height: 24
        };          
          const pointGraphic = new Graphic({
            geometry: point,
            symbol: markerSymbol
          });          
          this.$store.dispatch('response/setResponseCoordinates', [coords.latitude, coords.longitude])          
          view.graphics.add(pointGraphic);
        });
      }
    })
    .catch(err => {        
      console.error(err);
    });
  }
}
</script>

<style>
.map {
  height: 400px;
}

.map-title {
  padding: 12px;
  text-align: center;
}
</style>

